import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/modules/auth';
import { remoteSigningApi } from './remoteSigningApi';

export function useRemoteSigningNotice(): { companyPending: boolean } {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [pending, setPending] = useState(false);
  const userId = user?.userId;
  const organizationId = user?.organizationId;
  const external = user?.role === 'EXTERNAL';
  const companyAdmin = user?.role === 'ADMIN';
  useEffect(() => {
    setPending(false);
    if (!userId || !organizationId || external) return;
    let cancelled = false;
    const refresh = async () => {
      try {
        const availability = await remoteSigningApi.availability();
        if (!cancelled) {
          setPending(availability?.includedInPlan === true && availability.companyAssignmentPending === true);
        }
      } catch { console.warn('No se pudo actualizar el aviso de firma remota. Se reintentará al volver a la pantalla.'); }
    };
    void refresh();
    window.addEventListener('focus', refresh);
    window.addEventListener('remote-signing-assignment-changed', refresh);
    return () => {
      cancelled = true;
      window.removeEventListener('focus', refresh);
      window.removeEventListener('remote-signing-assignment-changed', refresh);
    };
  }, [userId, organizationId, external, companyAdmin, pathname]);
  return { companyPending: companyAdmin && !!organizationId && pending };
}
